import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldConfigName} from '../../../models';
import {EmailInputDialogComponent} from './email-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailInputComponent extends FieldControlMaster implements OnInit {
  @Output() emailInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() emailInputDelete = new EventEmitter<number>();
  dialogComponent = EmailInputDialogComponent;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.emailInputUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.emailInputDelete.emit(index);
  }
}
